import React, { Component } from 'react';
import TopNav from '../components/TopNav';
import MessageModal from './modal/MessageModal';
import moment from 'moment';
import { Redirect } from 'react-router-dom';
import { Bill } from '../Model/Bill';
import DeliveryDetailRepository from '../components/repository/DeliveryDetailRepository';
import './Payment.scss';
import SelectBankModal from './modal/SelectBankModal';
import { paymentTypeMap } from '../components/merchant/Enum/PaymentMethod';
import AppSettingRepository from '../components/repository/AppSettingRepository';
import AppData from '../Model/AppData';
import { TableSessionType } from '../app/Common/Enum/TableSessionType';
import MerchantSettingKey from '../app/Common/Enum/MerchantSettingKey';

// It seems minimum amount for Kiple is RM1.10
const KIPLE_RM1_AMOUNT = "1.10"
function DeliveryCharge({deliveryDetail, promoCodeDeliveryDiscount}) {
    if (deliveryDetail) {
        let deliveryCharge = (parseFloat(deliveryDetail.deliveryCharge || 0) - parseFloat(promoCodeDeliveryDiscount || 0)).toFixed(2)
        let shippingFee = deliveryCharge > 0 ? deliveryCharge : lang.free
        return <div className="order-confirm-font" style={{fontWeight: "bold"}}>
            <span style={{display:"inline-block"}}>{lang.delivery_charge}</span>
            <span style={{float: "right" , color: deliveryCharge > 0 ? "#636b6f" : "green", }}>{shippingFee}</span>
        </div>
    }
    return null
}
function PromoCodeDiscount({promoCodeDiscount}) {
    if (promoCodeDiscount && promoCodeDiscount != "0.00") {
        return <div className="order-confirm-font" style={{fontWeight: "bold", color: "red"}}>
            <span style={{display:"inline-block"}}>{lang.promo_code_discount}</span>
            <span style={{float: "right"}}>{promoCodeDiscount}</span>
        </div>
    }
    return null
}

export class Payment extends Component {
    constructor(props) {
        super(props)

        this.state = {
            calculated: false,
            kipleHash: "",
            kipleUrl: "",
            kipleMerchantId: "",
            kipleOrderRefNum: "",
            kiplePaymentCode: "CC",

            ipayHash: "",
            ipayUrl: "",
            ipayMerchantCode: "",

            ipayOrderRefNum: "",
            final: "",
            total: "",
            gotTax: false,
            tax: 0,
            currency: null,

            // To prevent user submitting payment request multiple times
            kipleButtonClicked: false,
            ipayButtonClicked: false,
            codButtonClicked: false,
            payAtKipleButtonClicked: false,

            isPeakHour: false,
        }
        this.now = moment().format('YYYYMMDDHHmmss')

        this.deliveryDetailCallbackKey = "Payment"
        this.callbackKey = "Payment"
    }

    componentWillUnmount() {
        DeliveryDetailRepository.getInstance().removeCallback(null, this)
        AppSettingRepository.getInstance().removeCallback(null, this)
    }
    getServiceChargePercent = () => {
        let scPercent = 0
        let serviceChargeGeneral = this.props.app.getMerchantSettingValue('service_charge')
        let serviceChargePickupDelivery = this.props.app.getMerchantSettingValue('service_charge_pickup_delivery')
        if (serviceChargePickupDelivery != null) {
            scPercent = serviceChargePickupDelivery
        }
        else if (serviceChargeGeneral != null) {
            scPercent = serviceChargeGeneral
        }
        return scPercent
    }

    calculateBill = () => {
        const tableSession = this.props.app.state.current_session
        let gotTax = this.props.app.state.merchant.tax_no != null
        let scPercent = this.getServiceChargePercent() // this.props.app.getMerchantSettingValue('service_charge')
        let extraSCstart = this.props.app.getMerchantSettingValue('extra_service_charge_start')
        let extraSCend = this.props.app.getMerchantSettingValue('extra_service_charge_end')
        let extraSCGetName = this.props.app.getMerchantSettingValue('extra_service_charge_name')
        let extraSCName = extraSCGetName != "" ? extraSCGetName : "Extra Surcharge"
        let extraSCPercent = this.props.app.getMerchantSettingValue('extra_service_charge_value')
        let extraSCValue = (extraSCPercent == null || extraSCPercent == 0) ? 0 : (extraSCPercent / 100.00);
        let serviceCharge = (scPercent == null || scPercent == 0) ? 0 : (scPercent / 100.00);
        let deliveryCharge = parseFloat(this.state.deliveryDetail && this.state.deliveryDetail.deliveryCharge || 0)
        let extraCharge = parseFloat(tableSession?.extra_data?.extra_charge?.value || 0)

        let roundTo = this.props.app.state.merchant.bill_round_to_nearest
        const billDetail = Bill.calculateBillDetailsForOrder({
            orders: this.props.app.state.orders, isHasTax: gotTax, pickupTime: this.props.app.state.table_session.pickup_time, serviceCharge, extraSCstart, extraSCend, extraSCName, extraSCValue, deliveryCharge, promoCode: tableSession.promo_code_data, extraCharge, roundTo
        })
        this.setState({
            final: billDetail.total.toFixed(2),
            total: billDetail.subtotal.toFixed(2),
            rounding: billDetail.rounding.toFixed(2),
            gotTax: gotTax,
            extraCharge: extraCharge.toFixed(2),
            extraSCName: extraSCName,
            extraServiceCharge: billDetail.extra_service_charge_value.toFixed(2),
            extraServiceChargePercent: extraSCPercent,
            serviceCharge: billDetail.service_charge.toFixed(2),
            serviceChargePercent: scPercent,
            tax: billDetail.tax.toFixed(2),
            promoCodeDiscount: billDetail.promo_code_discount.toFixed(2),
            promoCodeDeliveryDiscount: billDetail.promo_code_delivery_discount.toFixed(2),
        }, () => {
            this.getKipleHash()
            this.getIpayHash()
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.calculated &&
            this.props.app.state.merchant &&
            this.props.app.state.current_session &&
            this.props.app.state.orders &&
            this.props.app.state.orders.length > 0
            ) {


            let deliveryDetailId = this.props.app.state.current_session.delivery_detail_id
            if (deliveryDetailId && !this.state.deliveryDetail) {
                // Missing delivery details, load now wait for result
                // Make sure load once will do
                if (!this.state.isDeliveryChargeLoaded) {
                    this.setState({
                        isDeliveryChargeLoaded: true,
                    }, () => {
                        DeliveryDetailRepository.getInstance().loadOne(deliveryDetailId, (deliveryDetail) => {
                            this.setState({deliveryDetail})
                        }, this.deliveryDetailCallbackKey, this)
                    })
                }
                return
            }

            // We got all the information needed to calculate bill
            this.setState({
                calculated: true,
            }, () => {
                this.calculateBill()
            })
        }
    }

    componentDidMount() {
        this.props.app.loadTableIfNull(this.props.tableId)

        AppSettingRepository.getInstance().loadAll((appSettings) => {
            this.setState({appSettings}, this.handlePeakHour)
        }, this.callbackKey, this)
    }

    getKipleHash = () => {
        $.ajax({
            url     : `/customer/merchant/${merchant_id}/kiple_hash`,
            data    : {
                amount: this.isKipleForceRM1() ? KIPLE_RM1_AMOUNT : this.state.final,
                table_session_id: table_session_id,
            },
            success : (res) => {
                this.setState({
                    kipleHash: res.kiple_hash,
                    kipleUrl: res.kiple_url,
                    kipleMerchantId: res.kiple_merchant_id,
                    kipleOrderRefNum: res.kiple_order_ref_num,
                    kipleIsUat: res.is_uat,
                }, () => {
                    $(document).trigger('Payment.getKipleHash.success')
                })
            }
        })
        .fail(() => {
            this.setState({
                messageModal: <MessageModal
                    message={lang.unable_to_process_payment_request}
                    onClose={() => {
                        this.setState({
                            messageModal: null
                        })
                    }}
                />
            })
        })
    }
    getIpayHash = () => {
        $.ajax({
            url     : `/customer/merchant/${merchant_id}/ipay_hash`,
            data    : {
                amount: this.state.final,
                table_session_id: table_session_id,
            },
            success : (res) => {
                this.setState({
                    ipayHash: res.ipay_hash,
                    ipayUrl: res.ipay_url,
                    ipayMerchantCode: res.ipay_merchant_id,
                    ipayOrderRefNum: res.ipay_order_ref_num,
                }, () => {
                    $(document).trigger('Payment.getIpayHash.success')
                })
            }
        })
        .fail(() => {
            this.setState({
                messageModal: <MessageModal
                    message={lang.unable_to_process_payment_request}
                    onClose={() => {
                        this.setState({
                            messageModal: null
                        })
                    }}
                />
            })
        })
    }


    // This is to silent React warning of changing uncontrolled component
    // to controlled
    dummyOnChange = () => {}

    checkKipleUseUat = () => {
        if (this.state.kipleIsUat) {
            this.setState({
                kiplePaymentCode: "",
                kipleButtonClicked: true,
            }, () => $('#btn-kiple-submit').click())
            return true
        }
        return false
    }
    btnKipleFPXClicked = () => {
        if (this.checkKipleUseUat()) {
            return
        }
        this.setState({
            selectBankModal: <SelectBankModal
                onClose={() => this.setState({selectBankModal: null})}
                onNo={() => this.setState({selectBankModal: null})}
                onBankSelected={(paymentCode) => {
                    {/* this.setState({selectBankModal: null}) */}
                    this.setState({
                        kiplePaymentCode: paymentCode,
                        kipleButtonClicked: true,
                    }, () => $('#btn-kiple-submit').click())
                }}
            />
        })
    }
    btnKiplePayNowClicked = () => {
        if (this.checkKipleUseUat()) {
            return
        }
        $('#btn-kiple-submit').click()
        this.setState({
            kipleButtonClicked: true,
        })
    }
    btnIpayPayNowClicked = () => {
        $('#btn-ipay-submit').click()
        this.setState({
            ipayButtonClicked: true,
        })
    }
    btnPayAtKipleClicked = () => {
        this.setState({
            kiplePaymentCode: "",       // No payment code then shall choose at Kiple page
            payAtKipleButtonClicked: true,
        }, () => $('#btn-kiple-submit').click())
    }
    getTableAllowedPaymentMethod = () => {
        const { table } = this.props.app.state

        // Use global default payment setting set by merchant
        let allowPaymentStatus = {
            isTableAllowEWallet     : this.props.app.isMerchantHasFeature('all_table_payment_allow_ewallet'),
            isTableAllowFPX         : this.props.app.isMerchantHasFeature('all_table_payment_allow_fpx'),
            isTableAllowCreditCard  : this.props.app.isMerchantHasFeature('all_table_payment_allow_credit_card'),
            isTableAllowCOD         : this.props.app.isMerchantHasFeature('all_table_payment_allow_cod'),
        }

        // Override if table has specific setting
        if (table && table.payment_type_bitwise) {
            let a = table.payment_type_bitwise
            allowPaymentStatus = {
                isTableAllowEWallet     : !!(a & paymentTypeMap.PAYMENT_METHOD_EWALLET),
                isTableAllowFPX         : !!(a & paymentTypeMap.PAYMENT_METHOD_FPX),
                isTableAllowCreditCard  : !!(a & paymentTypeMap.PAYMENT_METHOD_CREDIT_CARD),
                isTableAllowCOD         : !!(a & paymentTypeMap.PAYMENT_METHOD_COD),
                isChooseAtKiple         : !!(a & paymentTypeMap.PAYMENT_METHOD_CHOOSE_AT_KIPLE),
            }
        }
        return allowPaymentStatus
    }
    btnCODClicked = () => {
        this.setState({
            codButtonClicked: true,
        })
        $.ajax({
            url: `/orders/use_cod_payment`,
            type: 'post',
            data: {
                merchant_id: this.props.app.state.table.merchant_id,
                table_id: this.props.app.state.table.id,
                order_status: "cash_on_delivery"
            },
            success: () => {}
        })
    }
    isDelivery = () => {
        return this.props.app.state.current_session && this.props.app.state.current_session.table_session_type_id == TableSessionType.DELIVERY && this.props.app.state.current_session.delivery_detail_id
    }
    handlePeakHour = () => {
        if (this.isDelivery()) {
            const pickupTime = moment(this.props.app.state.current_session.pickup_time, "YYYY-MM-DD hh:mm a")
            this.setState({
                isPeakHour: AppData.isPeakHour(this.state.appSettings, pickupTime)
            })
        }
    }
    isKipleForceRM1 = () => {
        return this.props.app.isMerchantHasFeature(MerchantSettingKey.IS_KIPLE_FORCE_RM1) == 1
    }
    render() {
        if (!table_session_id) {
            return <Redirect to={`/category/${this.props.match.params.tableQR}`} />
        }
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }

        const paymentImageContainerStyle = {
            textAlign: "center",
        }
        const paymentButtonStyle = {
            margin: "0px 0px 10px 0px"
        }
        const dummyOnChange = this.dummyOnChange
        const { customer, merchant } = this.props.app.state
        const {
            kipleHash, kipleUrl, kipleMerchantId, kiplePaymentCode,
            rounding, gotTax, kipleOrderRefNum,
            total, final, tax, deliveryDetail, serviceCharge,
            promoCodeDiscount,
            extraCharge,
            ipayHash, ipayUrl, ipayMerchantCode, ipayOrderRefNum,
            kipleButtonClicked, ipayButtonClicked, codButtonClicked, payAtKipleButtonClicked,
            promoCodeDeliveryDiscount, extraServiceCharge, extraSCName,
            serviceChargePercent, extraServiceChargePercent,
        } = this.state

        const { currencyName, currencyValue } = this.props

        const isIpayDebug = this.props.app.isMerchantHasFeature('is_ipay_use_debug_mode')
        const isKipleForceRM1 = this.isKipleForceRM1()

        const isAllowMakePayment = !ipayButtonClicked && !kipleButtonClicked && !codButtonClicked && !payAtKipleButtonClicked

        const minimumFPXValue = parseFloat(this.props.app.getMerchantSettingValue('kiple_minimum_fpx_value') || 40)
        const isAllowFPX = parseFloat(final || 0) >= minimumFPXValue

        const { isTableAllowEWallet, isTableAllowFPX, isTableAllowCreditCard, isTableAllowCOD, isChooseAtKiple, } = this.getTableAllowedPaymentMethod()
        const tableSession = this.props.app.state.current_session
        if (tableSession && !tableSession.is_pickup_confirmed) {
            return <Redirect to={`/pickup/${this.props.match.params.tableQR}`} />
        }
        let usdTotal = final/currencyValue
        if(usdTotal) {
            setTimeout(() => {
                this.setState({
                    delayTotalBar: <><span style={{display:"inline-block", fontSize: '40px'}}>{lang.total}</span>
                    <span style={{float: "right", fontSize: '40px' }}>{currencyName+" "+final} {this.props.app.isMerchantHasFeature('use_per_usd_price_show_at_checkout_page') ? "(USD "+parseFloat(usdTotal).toFixed(2)+")" : null}</span></> })
            }, 0);
        }

        // Cannot use fixed base url due to load balancer handling.
        // base_url are the direct url of the application server, where load balancer
        // points to general url. The cookie session from general url and server specific
        // url cannot be used interchangeably
        const hostName = window.location.hostname
        const port = window.location.port == 80 || window.location.port == 443 ? "" : `:${window.location.port}`
        const redirectBaseUrl = `https://${hostName}${port}/`


        let extraChargeReason = tableSession?.extra_data?.extra_charge?.reason || ""

        const ipayButtonOnClicked = ipayHash && isAllowMakePayment ? this.btnIpayPayNowClicked : null
        const kipleButtonOnClicked = kipleHash && isAllowMakePayment ? this.btnKiplePayNowClicked : null
        const fpxButtonOnClicked = kipleHash && isAllowMakePayment ? this.btnKipleFPXClicked : null
        return (
            <div style={{padding: '50px 10px 10px 10px'}}>
                {this.state.selectBankModal}
                {this.state.messageModal}
                <TopNav
                    table={this.props.app.state.table}
                    title={lang.review_order}
                    orders={this.props.app.state.orders}
                    onBack={() => {
                        // Make sure we back to pickup page.
                        // Using history.goBack() will give issue where if user
                        // arrived here from CartAndPinFooter, back will not
                        // bring user to pickup page
                        this.props.history.replace(`/pickup/${this.props.match.params.tableQR}`)
                    }}
                    backButton={true}
                    session={this.props.app.state.current_session}
                    backLabel={lang.back}
                />
                <div style={{marginBottom: '10px'}}>
                    <h3>{lang.review_payment + ":"}</h3>
                </div>
                <div>
                    <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                        <span style={{display:"inline-block"}}>{lang.sub_total}</span>
                        <span style={{float: "right" }}>{total}</span>
                    </div>
                </div>
                <hr style={{borderTop: "dotted 5px"}} />
                <div>
                    {
                        extraCharge > 0 &&
                        <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                            <span style={{display:"inline-block"}}>{extraChargeReason || lang.extra_charge}</span>
                            <span style={{float: "right" }}>{extraCharge}</span>
                        </div>
                    }
                    <div className="order-confirm-font" style={{fontWeight: "bold", color: "red"}}>
                        <span style={{display:"inline-block"}}>{lang.discount}</span>
                        <span style={{float: "right" }}>{"0.00"}</span>
                    </div>
                    <PromoCodeDiscount promoCodeDiscount={promoCodeDiscount} />
                    {
                        extraServiceCharge > 0 &&
                        <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                            <span style={{display:"inline-block"}}>{extraSCName} ({extraServiceChargePercent} %)</span>
                            <span style={{float: "right" }}>{extraServiceCharge}</span>
                        </div>
                    }
                    {
                        serviceCharge > 0 &&
                        <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                            <span style={{display:"inline-block"}}>{lang.service_charge} ({serviceChargePercent} %)</span>
                            <span style={{float: "right" }}>{serviceCharge}</span>
                        </div>
                    }
                    {gotTax ?
                        <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                            <span style={{display:"inline-block"}}>{lang.sst}</span>
                            <span style={{float: "right" }}>{tax}</span>
                        </div>
                    : ""}
                    <DeliveryCharge deliveryDetail={deliveryDetail} promoCodeDeliveryDiscount={promoCodeDeliveryDiscount} />
                    <div className="order-confirm-font" style={{fontWeight: "bold"}}>
                        <span style={{display:"inline-block"}}>{lang.rounding}</span>
                        <span style={{float: "right" }}>{rounding}</span>
                    </div>
                </div>
                <hr style={{borderTop: "dotted 5px"}} />
                <div>
                    <div className="order-font" style={{fontWeight: "bold"}}>
                        {this.state.delayTotalBar}
                    </div>
                    <div className="mt-2">{lang.choose_payment_method}</div>
                    <div style={{display:"flex",flexWrap: "wrap", justifyContent: "space-between"}}>
                        {
                            isAllowFPX && isTableAllowFPX &&
                            <div className="payment-type-container">
                                <div style={paymentButtonStyle}>
                                    <button style={{ display: "initial", width: "100%", padding: "3px 12px"}} id="payment-btn-pay-online"
                                        onClick={fpxButtonOnClicked} className={`btn btn-success active ${kipleHash && isAllowMakePayment ? "" : "disabled"}`}>
                                        <strong className="order-confirm-font">{lang.payment_method_online_banking}</strong>
                                    </button>
                                </div>
                                <div style={paymentImageContainerStyle}>
                                    <img src="/storage/online_payment/fpx.png" className="payment-image extra-height" onClick={fpxButtonOnClicked} />
                                </div>
                            </div>
                        }
                        {
                            isTableAllowEWallet && this.props.app.isMerchantHasFeature('is_allow_use_ipay') &&
                            <div className="payment-type-container">
                                <div style={paymentButtonStyle}>
                                    <button style={{ display: "initial", width: "100%", padding: "3px 12px"}} id="payment-btn-pay-ewallet"
                                        onClick={ipayButtonOnClicked} className={`btn btn-success active  ${ipayHash && isAllowMakePayment ? "" : "disabled"}`}>
                                        <strong className="order-confirm-font">{lang.payment_method_e_wallet}</strong>
                                    </button>
                                </div>
                                <div style={paymentImageContainerStyle}>
                                    <img src="/storage/online_payment/ewallet.png" className="payment-image" onClick={ipayButtonOnClicked}/>
                                </div>
                            </div>
                        }
                        {
                            isTableAllowCreditCard &&
                            <div className="payment-type-container" onClick={kipleButtonOnClicked}>
                                <div style={paymentButtonStyle}>
                                    <button style={{ display: "initial", width: "100%", padding: "3px 12px"}} id="payment-btn-pay-online"
                                     className={`btn btn-success active ${kipleHash && isAllowMakePayment ? "" : "disabled"}`}>
                                        <strong className="order-confirm-font">{lang.payment_method_cc_bank}</strong>
                                    </button>
                                </div>
                                <div style={paymentImageContainerStyle}>
                                    <img src="/storage/online_payment/visa-master.png" className="payment-image" onClick={kipleButtonOnClicked}/>
                                </div>
                            </div>
                        }
                        {
                            isTableAllowCOD &&
                            <div className="payment-type-container">
                                <div style={paymentButtonStyle}>
                                    <button style={{ display: "initial", width: "100%", padding: "3px 12px"}} id="payment-btn-pay-cod"
                                        onClick={isAllowMakePayment ? this.btnCODClicked : null} className={`btn btn-success active ${isAllowMakePayment ? "" : "disabled"}`}>
                                        <strong className="order-confirm-font">{lang.payment_method_cod}</strong>
                                    </button>
                                </div>
                            </div>
                        }
                        {
                            isChooseAtKiple &&
                            <div className="payment-type-container">
                                <div style={paymentButtonStyle}>
                                    <button style={{ display: "initial", width: "100%", padding: "3px 12px"}} id="payment-btn-pay-kiple"
                                        onClick={isAllowMakePayment ? this.btnPayAtKipleClicked : null} className={`btn btn-success active ${isAllowMakePayment ? "" : "disabled"}`}>
                                        <strong className="order-confirm-font">{lang.proceed_to_make_payment}</strong>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <form style={{display: 'none'}} method='post' action={`${kipleUrl}`}>
                    <input type="hidden" readOnly name="ord_date" value={moment().format('DD MMMM YYYY')} />
                    <input type="text" readOnly name="ord_totalamt" value={isKipleForceRM1 ? KIPLE_RM1_AMOUNT : (final || "")} onChange={dummyOnChange} />
                    <input type="text" readOnly name="ord_gstamt" value="0.00" />
                    <input type="hidden" readOnly name="ord_shipname" value={merchant.name || ""} />
                    <input type="hidden" readOnly name="ord_shipcountry" value="Malaysia" />
                    <input type="hidden" readOnly name="ord_mercref" value={kipleOrderRefNum || ""} onChange={dummyOnChange} />
                    <input type="hidden" readOnly name="ord_email" value={merchant.email || ""} />
                    <input type="text" readOnly name="ord_mercID" value={kipleMerchantId || ""} onChange={dummyOnChange} />
                    <input type="text" readOnly name="merchant_hashvalue" value={kipleHash || ""} onChange={dummyOnChange} />
                    <input type="hidden" readOnly name="ord_returnURL" value={`${redirectBaseUrl}payment/kiplepay/callback?tableQR=${this.props.match.params.tableQR}`} />
                    <input type="hidden" readOnly name="payment_code" value={kiplePaymentCode} />
                    <input type='hidden' readOnly name='version' value='2.0' />
                    <input type="submit" name="submit" value="Pay with kiplePay" id='btn-kiple-submit' />
                </form>
                {
                    this.props.app.isMerchantHasFeature('is_allow_use_ipay') &&
                    <form style={{display: 'none'}} method='post' action={`${ipayUrl}`}>
                        <input type="text" readOnly name="Amount" value={isIpayDebug && '1.00' || final.toLocaleString(navigator.language, {minimumFractionDigits: 2})} />
                        <input type="text" readOnly name="Currency" value="MYR" />
                        <input type="text" readOnly name="ProdDesc" value={merchant.name} />
                        <input type="hidden" readOnly name="UserName" value={customer && customer.name} />
                        <input type="hidden" readOnly name="UserEmail" value={customer && customer.email} />
                        <input type="hidden" readOnly name="UserContact" />
                        <input type="hidden" readOnly name="SignatureType" value="HMACSHA512" />
                        <input type="hidden" readOnly name="Signature" value={ipayHash} />
                        <input type="hidden" readOnly name="RefNo" value={ipayOrderRefNum} />
                        <input type="text" readOnly name="MerchantCode" value={ipayMerchantCode} />
                        <input type="hidden" readOnly name="ResponseURL" value={`${redirectBaseUrl}payment/ipay/callback?tableQR=${this.props.match.params.tableQR}`} />
                        <input type="hidden" readOnly name="BackendURL" value={`${redirectBaseUrl}payment/ipay/backend/callback?tableQR=${this.props.match.params.tableQR}`} />
                        <input type="submit" name="submit" value="Pay with iPay" id='btn-ipay-submit' />
                    </form>
                }

                {
                    this.isDelivery() && this.state.isPeakHour &&
                    <div className="mt-2">
                        <span style={{ color: "darkred", fontWeight: "bold" }}>{lang.peak_hour_hint}</span>
                    </div>
                }
            </div>
        )
    }
}